module.exports = __webpack_public_path__ + "img/10551377_L.9ae0ff71.png";